/**
 * @brief bi汉语语言包配置
 * @date 2024年07月03日11:10:32
 */
export default {
  '该图表是关联图表，已同时被其他仪表盘关联，对该图表的编辑操作将同时影响其所有已关联的图表': '该图表是关联图表，已同时被其他仪表盘关联，对该图表的编辑操作将同时影响其所有已关联的图表',
  暂无图表查看权限: '暂无图表查看权限',
  下钻到市: '下钻到市',
  查看数据: '查看数据',
  '图表导出中，导出后的文件将通过飞书消息卡片进行通知': '图表导出中，导出后的文件将通过飞书消息卡片进行通知',
  '图表配置异常，请编辑检查图表配置': '图表配置异常，请编辑检查图表配置',
  驾驶舱: '驾驶舱',
  仪表盘显隐设置: '仪表盘显隐设置',
  取消图表关联: '取消图表关联',
  确定将所选图表取消与其它仪表盘内该图表的关联吗: '确定将所选图表取消与其它仪表盘内该图表的关联吗',
  '取消关联后，将创建该图表的副本，且对该图表的后续操作将不影响其它仪表盘内已关联的图表': '取消关联后，将创建该图表的副本，且对该图表的后续操作将不影响其它仪表盘内已关联的图表',
  仅查看: '仅查看',
  添加仪表盘: '添加仪表盘',
  新建仪表盘: '新建仪表盘',
  复制仪表盘: '复制仪表盘',
  编辑仪表盘: '编辑仪表盘',
  从图表库添加: '从图表库添加',
  新建图表: '新建图表',
  筛选配置: '筛选配置',
  全屏显示: '全屏显示',
  '近7天(含今日)': '近7天(含今日)',
  '近7天(不含今日)': '近7天(不含今日)',
  '近30天(含今日)': '近30天(含今日)',
  '近30天(不含今日)': '近30天(不含今日)',
  '无新建仪表盘权限，请联系管理员': '无新建仪表盘权限，请联系管理员',
  '可新建仪表盘，开始搭建你的数据驾驶舱': '可新建仪表盘，开始搭建你的数据驾驶舱',
  '选择一个图表组件，开始搭建你的仪表盘': '选择一个图表组件，开始搭建你的仪表盘',
  '快速插入柱状图、折线图、饼图等多种组件类型，直观展示数据，让业务动态一目了然': '快速插入柱状图、折线图、饼图等多种组件类型，直观展示数据，让业务动态一目了然',
  无新建图表权限: '无新建图表权限',
  请联系管理员: '请联系管理员',
  退出全屏: '退出全屏',
  暂无图表: '暂无图表',
  类型筛选: '类型筛选',
  默认筛选日期: '默认筛选日期',
  请选择默认筛选日期: '请选择默认筛选日期',
  请选择图表: '请选择图表',
  筛选字段: '筛选字段',
  '字段异常，请检查字段状态': '字段异常，请检查字段状态',
  '删除操作不可恢复，是否确定删除当前仪表盘': '删除操作不可恢复，是否确定删除当前仪表盘',
  退出后当前修改将失效: '退出后当前修改将失效',
  确认退出: '确认退出',
  全部图表: '全部图表',
  我创建的: '我创建的',
  我可编辑的: '我可编辑的',
  全部图表类型: '全部图表类型',
  柱状图: '柱状图',
  折线图: '折线图',
  饼图: '饼图',
  指标卡: '指标卡',
  数据表: '数据表',
  地图: '地图',
  请输入图表名称: '请输入图表名称',
  图表名称: '图表名称',
  是否确定从当前仪表盘移除该图表: '是否确定从当前仪表盘移除该图表',
  '删除操作不可恢复，是否确定删除当前图表': '删除操作不可恢复，是否确定删除当前图表',
  立即创建: '立即创建',
  仪表盘名称: '仪表盘名称',
  仪表盘名称是必填项: '仪表盘名称是必填项',
  请输入仪表盘名称: '请输入仪表盘名称',
  查看权限: '查看权限',
  请选择数据权限: '请选择数据权限',
  公开: '公开',
  私有: '私有',
  部分人可见: '部分人可见',
  查看人员: '查看人员',
  导出权限: '导出权限',
  编辑权限: '编辑权限',
  删除权限: '删除权限',
  权限设置: '权限设置',
  图表库: '图表库',

  创建图表: '创建图表',
  编辑图表: '编辑图表',
  复制图表: '复制图表',
  数据来源: '数据来源',
  请选择数据来源: '请选择数据来源',
  请选择对象: '请选择对象',
  '（异常）': '（异常）',
  数据范围: '数据范围',
  请选择数据范围: '请选择数据范围',
  添加条件: '添加条件',
  图表类型: '图表类型',
  请选择图表类型: '请选择图表类型',
  '请选择横轴(维度)': '请选择横轴(维度)',
  '请选择纵轴(指标)': '请选择纵轴(指标)',
  '请选择扇形分组(维度)': '请选择扇形分组(维度)',
  '请选择扇形数值(指标)': '请选择扇形数值(指标)',
  '请选择行(维度)': '请选择行(维度)',
  '请选择列(指标)': '请选择列(指标)',
  请选择主指标: '请选择主指标',
  请选择次指标: '请选择次指标',
  '1个维度': '1个维度',
  '0~10个维度': '0~10个维度',
  '1个指标': '1个指标',
  '1~10个指标': '1~10个指标',
  '1~20个指标': '1~20个指标',
  '0~5个指标': '0~5个指标',
  '0~4个指标': '0~4个指标',
  '横轴(维度)': '横轴(维度)',
  '纵轴(指标)': '纵轴(指标)',
  '扇形分组(维度)': '扇形分组(维度)',
  '扇形数值(指标)': '扇形数值(指标)',
  主指标: '主指标',
  次指标: '次指标',
  '行(维度)': '行(维度)',
  '列(指标)': '列(指标)',
  请选择字段: '请选择字段',
  分组聚合: '分组聚合',
  '0~1个分组': '0~1个分组',
  排序规则: '排序规则',
  请选择排序规则: '请选择排序规则',
  应用: '应用',
  全部数据: '全部数据',
  条件范围数据: '条件范围数据',
  更改数据源: '更改数据源',
  '更改数据源将清空当前图标配置，是否确认修改？': '更改数据源将清空当前图标配置，是否确认修改？',
  提醒: '提醒',
  '该图表为关联图表，已同时被其它仪表盘关联，保存后将同步影响其它仪表盘下图表，是否确认保存？': '该图表为关联图表，已同时被其它仪表盘关联，保存后将同步影响其它仪表盘下图表，是否确认保存？',
  添加字段: '添加字段',
  输入关键字搜索: '输入关键字搜索',
  '最多添加10个维度！': '最多添加10个维度！',
  '最多添加1个维度！': '最多添加1个维度！',
  '最多添加10个指标！': '最多添加10个指标！',
  '最多添加1个指标！': '最多添加1个指标！',
  '最多添加20个指标！': '最多添加20个指标！',
  '最多添加5个指标！': '最多添加5个指标！',
  '最多添加4个指标！': '最多添加4个指标！',
  '最多添加1个分组聚合字段！': '最多添加1个分组聚合字段！',
  升序: '升序',
  降序: '降序',
  基础柱状图: '基础柱状图',
  堆积柱状图: '堆积柱状图',
  基础折线图: '基础折线图',
  平滑折线图: '平滑折线图',
  阶梯折线图: '阶梯折线图',
  环形图: '环形图',
  求和: '求和',
  平均值: '平均值',
  计数: '计数',
  最大值: '最大值',
  最小值: '最小值',
  年: '年',
  '年-季': '年-季',
  '年-月': '年-月',
  '年-月-日': '年-月-日',
  数字: '数字',
  金额: '金额',
  百分比: '百分比',
  整数: '整数',
  保留1位小数: '保留1位小数',
  保留2位小数: '保留2位小数',
  保留3位小数: '保留3位小数',
  保留4位小数: '保留4位小数',
  保留5位小数: '保留5位小数',
  保留6位小数: '保留6位小数',
  保留7位小数: '保留7位小数',
  保留8位小数: '保留8位小数',
  '当前数据源有异常，请检查数据源状态和权限!': '当前数据源有异常，请检查数据源状态和权限!',
  '当前横轴/指标字段有异常，请检查字段状态!': '当前横轴/指标字段有异常，请检查字段状态!',
  '当前纵轴/指标字段有异常，请检查字段状态!': '当前纵轴/指标字段有异常，请检查字段状态!',
  '当前次指标字段有异常，请检查字段状态!': '当前次指标字段有异常，请检查字段状态!',
  '当前分组聚合字段有异常，请检查字段状态!': '当前分组聚合字段有异常，请检查字段状态!',
  '当前排序字段有异常，请检查字段状态!': '当前排序字段有异常，请检查字段状态!',
  图表字段: '图表字段',
  请输入图表字段: '请输入图表字段',
  显示名称: '显示名称',
  请输入显示名称: '请输入显示名称',
  汇总方式: '汇总方式',
  请选择汇总方式: '请选择汇总方式',
  计算方式: '计算方式',
  请选择计算方式: '请选择计算方式',
  格式: '格式',
  请选择格式: '请选择格式',
  小数位数: '小数位数',
  请选择小数位数: '请选择小数位数',
  图表基础信息: '图表基础信息',
  图表标题: '图表标题',
  请输入图表标题: '请输入图表标题',
  图表描述: '图表描述',
  请输入图表描述: '请输入图表描述',
  主题色: '主题色',
  图表主题: '图表主题',
  请选择主题色: '请选择主题色',
  字体颜色与字号: '字体颜色与字号',
  横轴: '横轴',
  横轴标题: '横轴标题',
  请输入横轴标题: '请输入横轴标题',
  显示标签: '显示标签',
  标签位置: '标签位置',
  纵轴: '纵轴',
  纵轴标题: '纵轴标题',
  图例位置: '图例位置',
  地图钻取: '地图钻取',
  扇区样式: '扇区样式',
  系列样式: '系列样式',
  显示数据标签: '显示数据标签',
  数据标签位置: '数据标签位置',
  数据标签字体颜色与字号: '数据标签字体颜色与字号',
  标签内容: '标签内容',
  请选择标签内容: '请选择标签内容',
  '网格&刻度&轴线': '网格&刻度&轴线',
  计算总结果: '计算总结果',
  垂直向上: '垂直向上',
  左起斜上: '左起斜上',
  横排: '横排',
  左起斜下: '左起斜下',
  垂直向下: '垂直向下',
  横轴网格线: '横轴网格线',
  横轴刻度: '横轴刻度',
  横轴轴线: '横轴轴线',
  纵轴网格线: '纵轴网格线',
  纵轴刻度: '纵轴刻度',
  纵轴轴线: '纵轴轴线',
  顶部: '顶部',
  左侧: '左侧',
  右侧: '右侧',
  底部: '底部',
  隐藏: '隐藏',
  跟随主题色: '跟随主题色',
  自定义填充色: '自定义填充色',
  外部: '外部',
  居中: '居中',
  内部: '内部',
  扇形类别: '扇形类别',
  值: '值',
  不显示: '不显示',
  显示维度值: '显示维度值',
  显示主指标值: '显示主指标值',
  钻取到省: '钻取到省',
  不允许钻取: '不允许钻取',
  查看全部数据: '查看全部数据',
  '当前窗口区域过窄，无法添加图表': '当前窗口区域过窄，无法添加图表',
  '当前窗口过小，无法编辑。请调整窗口后再进行编辑操作': '当前窗口过小，无法编辑。请调整窗口后再进行编辑操作',
  '当前窗口区域过窄，无法添加图表。请调整窗口后再进行操作': '当前窗口区域过窄，无法添加图表。请调整窗口后再进行操作',
  '当前窗口过小，无法复制。请调整窗口后再进行复制操作': '当前窗口过小，无法复制。请调整窗口后再进行复制操作',
  柱状图类型: '柱状图类型',
  折线图类型: '折线图类型',
  饼图类型: '饼图类型',
  指标卡类型: '指标卡类型',
  地图类型: '地图类型',
  数据表类型: '数据表类型',
  自定义排序: '自定义排序',
  '仪表盘设计有修改，是否保存': '仪表盘设计有修改，是否保存',
  '你修改了仪表盘设计但没有保存，是否需要保存仪表盘设计并继续': '你修改了仪表盘设计但没有保存，是否需要保存仪表盘设计并继续',
  返回仪表盘设计: '返回仪表盘设计',
  不保存: '不保存',
  保存并继续: '保存并继续',
  取消勾选展示全部数据: '取消勾选展示全部数据',
  显示前: '显示前',
  条数据: '条数据'
};
